import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const CheckboxInput = ({ field = {}, label = '', linkLabel = null, ...rest }) => (
  <FormControlLabel
    control={<Checkbox {...field} {...rest} checked={field?.value} />}
    label={
      <span>
        <span>{label}</span>
        <a key={linkLabel} href='/'>
          {linkLabel}
        </a>
      </span>
    }
  />
);

export default CheckboxInput;
